export default __webpack_public_path__ + "static/media/blackboard-landscape.34c5a62f.jpg";